/**
 * After a new frontend deploy, old tab sessions still reference previous hashed chunk URLs.
 * Dynamic import then fails with "Failed to fetch dynamically imported module".
 * One hard reload fetches fresh index + manifest; we do that at most once per failure streak.
 */
const STORAGE_KEY = 'rms:stale-chunk-reload'

export function isStaleChunkLoadError(err) {
  const msg = typeof err === 'string' ? err : (err?.message || String(err || ''))
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('error loading dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    /Loading chunk [\w-]+ failed/i.test(msg)
  )
}

/** @returns {boolean} true if a reload was triggered */
export function reloadOnceForStaleChunk(err) {
  if (!isStaleChunkLoadError(err) || typeof window === 'undefined') return false
  try {
    const n = parseInt(sessionStorage.getItem(STORAGE_KEY) || '0', 10)
    if (n >= 1) return false
    sessionStorage.setItem(STORAGE_KEY, '1')
    window.location.reload()
    return true
  } catch {
    return false
  }
}

/** Call after a successful app mount so the next deploy can trigger recovery again. */
export function clearStaleChunkReloadMarker() {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
